//<editor-fold desc="HASH-HELPER">

class PortunaHash
{
    values: Record<string, any> = {};

    constructor()
    {
        this.init();
    }

    rebuild()
    {
        this.init();
    }

    /**
     * reads the current location hash and fills the internal values array
     *
     * @returns {PortunaHash}
     * @private
     */
    init(): PortunaHash
    {
        this.values = {};

        let hash = window.location.hash.slice(1);

        if ('' !== hash)
        {
            let _hash = hash.split('&');

            for (let hashValue of _hash)
            {
                let key,
                    value,
                    currentHash,
                    attr = this.values;

                currentHash = hashValue.split('=');
                key         = decodeURIComponent(currentHash[0]);
                value       = decodeURIComponent(currentHash[1]);

                // json encoded value
                if (['{', '['].includes(value.substr(0, 1)))
                {
                    value = JSON.parse(value);
                }
                // add array support like '#search[title]=test&search[awesome]=1'
                else if (-1 !== key.indexOf('['))
                {
                    let matches = key.match(/\[(.*?)]/g);
                    key         = key.substring(0, key.indexOf('['));

                    if (matches)
                    {
                        while (key)
                        {
                            key = key.replace(/[\[\]]/g, '');

                            // don't change 'attr' at last index!
                            //+ e.g. search[title]=test -> obj.attributes[search][title] = 'test'
                            if (0 === matches.length)
                            {
                                break;
                            }

                            // initialize as object
                            if (!attr[key] || 'object' !== typeof attr[key])
                            {
                                attr[key] = {};
                            }

                            attr = attr[key];
                            key  = matches.shift();
                        }
                    }
                }

                attr[key as string] = value;
            }
        }

        return this;
    }

    /**
     * set the `key` to `value` - overwrite if already exists
     *
     * @param {string} key used key
     * @param {*} value value for `key`
     * @returns {PortunaHash}
     */
    set(key: string, value: any): PortunaHash
    {
        this.values[key]     = value;
        window.location.hash = this.getAsString();

        return this;
    }

    /**
     * get the value of `key`
     *
     * @param {string} key used key
     * @returns {*}
     */
    get(key: string): any
    {
        let value = this.values[key];

        if ('false' === value)
        {
            value = false;
        }
        else if ('true' === value)
        {
            value = true;
        }
        else if ('undefined' === typeof value
            || ('undefined' === value && 'string' === typeof value)
        )
        {
            value = undefined;
        }
        else if ('null' === value)
        {
            value = null;
        }

        return value;
    }

    /**
     * whether the key exists
     *
     * @param {string} key used key
     * @returns {boolean}
     * @private
     */
    isset(key: string): boolean
    {
        return ('undefined' !== typeof this.values[key]);
    }

    /**
     * deletes the key
     *
     * @param {string} key used key
     * @returns {PortunaHash}
     */
    unset(key: string): PortunaHash
    {
        delete this.values[key];
        window.location.hash = this.getAsString();

        return this;
    }

    /**
     * helper function for getAsString(false) - generates the form-like array
     *
     * @param {string} key used key
     * @param {*} value value for key
     * @returns {string}
     */
    getArrayFormat(key: string, value: any[]): string
    {
        let out = [];

        for (let _key in value)
        {
            if (!value.hasOwnProperty(_key))
            {
                continue;
            }

            let _value = value[_key];
            out.push(null !== _value && 'object' === typeof _value ? this.getArrayFormat(key + '[' + _key + ']', _value) : key + '[' + _key + ']=' + encodeURIComponent(_value));
        }

        return out.join('&');
    }

    /**
     * returns the whole hash as string
     *
     * @param {boolean} json if true, a JSON string is returned, if false, a form array is generated.
     * @returns {string}
     */
    getAsString(json: boolean = true): string
    {
        json = json || false;

        this.init();
        let hash: string[] = [];

        for (let key in this.values)
        {
            if (!this.values.hasOwnProperty(key))
            {
                continue;
            }

            let value = this.values[key];

            if ('undefined' !== typeof value)
            {
                if (null !== value && 'object' === typeof value)
                {
                    if (json)
                    {
                        value = encodeURIComponent(JSON.stringify(value));
                    }
                    else
                    {
                        // do not call encodeURIComponent
                        value = this.getArrayFormat(key, value);
                    }
                }
                else
                {
                    value = encodeURIComponent(value);
                }

                hash.push(key + '=' + value);
            }
            else
            {
                hash.push(key);
            }
        }

        return hash.join('&');
    }

}

export const Hash = new PortunaHash;
//</editor-fold>